import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        scrollPosition_y: 0,
        portfolioSelected: null,
        messageSent: false,

        /* Components' shown statuses */
        disclaimerShown: false,
        portfolioShown: false,
        messageStatusShown: false
    },
    mutations: {
        GET_SCROLL_POSITION: (state) => {
            state.scrollPosition_y = document.documentElement.scrollTop;
        },
        SET_PORTFOLIO_SELECTED: (state, portfolioKey) => {
            state.portfolioSelected = portfolioKey;
        },

        /* Show/hide components */
        SHOW_DISCLAIMER_MODAL: (state, value) => {
            state.disclaimerShown = value;
        },
        SHOW_PORTFOLIO_MODAL: (state, value) => {
            state.portfolioShown = value;
        },
        SHOW_MESSAGE_STATUS: (state, payload) => {
            state.messageStatusShown = payload.shown;

            if (payload.shown){
                payload.messageSent = payload.isMessageSent;
            }
        }
    },
    actions: {
        getScrollPosition: ({commit}) => {
            commit('GET_SCROLL_POSITION');
        },
        setPortfolioSelected: ({commit}, portfolioKey) => {
            commit('SET_PORTFOLIO_SELECTED', portfolioKey);
        },

        /* Show/hide components */
        showDisclaimerModal: ({commit}, value) => {
            commit('SHOW_DISCLAIMER_MODAL', value);
        },
        showPortfolioModal: ({commit}, value) => {
            commit('SHOW_PORTFOLIO_MODAL', value);
        },
        showMessageStatus: ({commit}, payload) => {
            commit('SHOW_MESSAGE_STATUS', payload);
        }
    }
});